import React, { useContext, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { appContext } from '../../service/AppContext';
import './BannerPicker.css';

export default function BannerPicker({ value, onChange, languageCode }) {
    const { breslevRequest } = useContext(appContext);
    const [available, setAvailable] = useState([]);
    const [loading, setLoading] = useState(false);
    const prevLang = useRef(languageCode);

    const load = async () => {
        if (!languageCode) {
            setAvailable([]);
            return;
        }
        setLoading(true);
        const res = await breslevRequest({
            method: 'GET',
            route: '/broadcast/banners',
            params: { language_code: languageCode },
        });
        if (res?.status === 200 && Array.isArray(res.data)) {
            setAvailable(res.data);
        } else {
            toast('שגיאה בטעינת באנרים');
        }
        setLoading(false);
    };

    useEffect(() => {
        // Banner posts are per-language — clear the selection when the
        // broadcast language changes (but not on the initial mount).
        if (prevLang.current !== languageCode) {
            prevLang.current = languageCode;
            onChange(null);
        }
        load();
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [languageCode]);

    const select = (id) => {
        // Clicking the selected banner again clears it (selection is optional).
        onChange(value === id ? null : id);
    };

    return (
        <div className='banner-picker'>
            {loading && <span className='bp-loading'>טוען...</span>}
            <div className='bp-list'>
                {available.map(b => (
                    <button
                        type='button'
                        key={b.id}
                        className={'bp-card' + (value === b.id ? ' bp-card-on' : '')}
                        onClick={() => select(b.id)}
                    >
                        {b.banner_image_url
                            ? <img className='bp-thumb' src={b.banner_image_url} alt='' />
                            : <div className='bp-thumb bp-thumb-empty' />}
                        <span className='bp-title'>{b.title}</span>
                    </button>
                ))}
                {(!available.length && !loading) && (
                    <div className='bp-empty'>אין באנרים זמינים בשפה זו</div>
                )}
            </div>
        </div>
    );
}
